// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3xcHD","header":"ReportDetails_header__3r2Q9","title":"ReportDetails_title__2XqOP","left":"ReportDetails_left__LNRrL"};